import { ResponseError } from '../../../services/api';

export enum ScreenFormTypes {
  'LOAD_REQUEST' = '@screenForm/LOAD_REQUEST',
  'LOAD_SUCCESS' = '@screenForm/LOAD_SUCCESS',
  'LOAD_FAILURE' = '@screenForm/LOAD_FAILURE',

  'SEND_REQUEST' = '@screenForm/SEND_REQUEST',
  'SEND_SUCCESS' = '@screenForm/SEND_SUCCESS',
  'SEND_FAILURE' = '@screenForm/SEND_FAILURE',

  'CLEAN_STATE' = '@screenForm/CLEAN_STATE',
}

export interface Fields {
  columnSize: number;
  defaultValue?: any;
  description: string;
  enable?: boolean;
  fieldName: string;
  fieldType:
    | 'OPTIONS'
    | 'BLOB'
    | 'CLOB'
    | 'STRING'
    | 'INTEGER'
    | 'FLOAT'
    | 'DATE'
    | 'DATE_TIME'
    | 'TIME'
    | 'TEXT_AREA';
  foreignEntity: string;
  grouping: string;
  id: number;
  idField: number;
  mask?: 'currency' | 'cpfCnpj' | 'phone' | 'date' | 'dateTime' | 'cep' | 'email';
  position: number;
  required?: boolean;
  tableName: string;
  visible?: boolean;
}

export interface ScreenForm {
  title: string;
  fields: Fields[];
}

export interface Success {
  id: number;
  message: string;
}
export interface SendObject {
  id?: number;
  name: string;
  value: any;
}

export interface ScreenFormState {
  readonly data: ScreenForm[];
  readonly sendLoading: boolean;
  readonly success?: Success;
  readonly sendError?: ResponseError;
  readonly loading: boolean;
  readonly error?: ResponseError;
}
